var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Absolute3DPosition, GeographicalPosition, SerializableArrayMember, SerializableMember, SerializableObject, } from '@openhps/core';
import { CellBoundary } from './CellBoundary';
import { SymbolicSpace } from '../SymbolicSpace';
import { Slant } from './Slant';
let CellSpace = class CellSpace extends SymbolicSpace {
    constructor() {
        super(...arguments);
        this.boundaries = [];
    }
    setFloor(floor) {
        this.parent = floor;
        this.priority = floor.priority + 1;
        return this;
    }
    set parent(floor) {
        super.parent = floor;
    }
    get parent() {
        return super.parent;
    }
    setArrayBounds(localBounds) {
        if (localBounds.length > 0 && localBounds[0] instanceof GeographicalPosition) {
            return super.setArrayBounds(localBounds);
        }
        const bounds = localBounds.map((bound) => {
            const vector = bound.toVector3();
            return new Absolute3DPosition(vector.x, vector.y, 0);
        });
        if (this.parent && this.parent.ceilingHeight) {
            bounds.push(...bounds.map((bound) => {
                const clonedBound = bound.clone();
                clonedBound.z = clonedBound.z + this.parent.ceilingHeight;
                return clonedBound;
            }));
            if (localBounds.length === 2) {
                bounds.splice(1, 2);
            }
        }
        super.setArrayBounds(bounds);
        return;
    }
};
__decorate([
    SerializableArrayMember(CellBoundary),
    __metadata("design:type", Array)
], CellSpace.prototype, "boundaries", void 0);
__decorate([
    SerializableMember(),
    __metadata("design:type", Slant)
], CellSpace.prototype, "slant", void 0);
CellSpace = __decorate([
    SerializableObject()
], CellSpace);
export { CellSpace };
//# sourceMappingURL=CellSpace.js.map